import { customRuleCategoryApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const RULE_CATEGORIES_ACTION_TYPE = createNamedActions('ruleCategories', {
  GET_RULE_CATEGORIES: 'GET_RULE_CATEGORIES',
});

const categories = new schema.Entity('categories', {}, { idAttribute: 'name' });

export const getRuleCategoriesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await customRuleCategoryApi.getCustomRuleCategory();

  return dispatch({
    type: RULE_CATEGORIES_ACTION_TYPE.GET_RULE_CATEGORIES,
    payload: normalize(data, [categories]).entities.categories,
  });
});
